export class StatusEventSignalParsingException extends Error {

  type: string;
  message: string;

  constructor(type: string,message: string ) {
    super(message);
    this.type = type;
    this.message = message;
  }
}